import { ControlledSelect } from 'modules/common/components';
import Select from 'modules/common/components/Select';
import { Dislikes } from 'modules/donations/components/DislikesSelect/enum';
import { ComponentProps, FC } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

type Props = {
  controlled: UseControllerProps<any>;
} & ComponentProps<typeof Select>;

const t = getTranslation('donation.DislikesSelect');

const dislikesOptions = Object.values(Dislikes).map((value) => {
  return {
    value,
    label: t(value.charAt(0).toLowerCase() + value.slice(1)),
  };
});

export const DislikesSelect: FC<Props> = ({ controlled, ...otherProps }) => {
  return (
    <ControlledSelect
      {...otherProps}
      options={dislikesOptions}
      defaultValue={undefined}
      controlled={controlled}
      placeholder={t('selectDislikesSelect')}
      mode="tags"
    />
  );
};
